export const TEST_CASE_CATEGORIES = ["Functional", "E2E"];

/** Map DB / CSV values to Functional or E2E tab bucket. */
export function resolveTestCaseCategory(typeOfTestCase) {
  const v = String(typeOfTestCase || "").trim().toLowerCase();
  if (v === "e2e" || v === "e-2-e") return "E2E";
  return "Functional";
}

/** Normalize user/CSV input to stored type_of_test_case value. */
export function normalizeTypeOfTestCase(value, fallback = "Functional") {
  const v = String(value || "").trim().toLowerCase();
  if (v === "e2e" || v === "e-2-e") return "E2E";
  if (v === "functional") return "Functional";
  return fallback;
}
